module.exports = __webpack_public_path__ + "static/img/homes4.4cc2f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/homes4.png
// module id = Aj/s
// module chunks = 2